import styled from "styled-components/macro";

export const StyledButton = styled('button')<any>`
  background: ${(p) => p.color || '#0f0f0f'};
  color: ${(p) => (p.color ? '#0f0f0f' : 'rgb(255, 255, 255)')};

  text-decoration: none;
  border: 4px solid white;
  padding: 10px 25px;
  border-radius: 5px;

  font-size: 14px;
  font-family: "Oswald";

  text-transform: uppercase;
  text-align: center;
  letter-spacing: 2px;

  width: fit-content;

  cursor: pointer;

  @media (max-width: 450px) {
    font-size: 14px;
    padding: 8px 15px;
  }

`;
